var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalAdvertenciaIcono(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 8.25C12.9142 8.25 13.25 8.58579 13.25 9V14C13.25 14.4142 12.9142 14.75 12.5 14.75C12.0858 14.75 11.75 14.4142 11.75 14V9C11.75 8.58579 12.0858 8.25 12.5 8.25Z",
    fill: "#FE0130"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5003 3.34253C11.7005 3.34253 10.7327 3.89142 9.91625 5.36374L3.85626 16.2637C3.09577 17.6353 3.12829 18.7172 3.53589 19.4116C3.94308 20.1053 4.8701 20.66 6.44034 20.66H12.5013C12.5432 20.66 12.5842 20.6635 12.6241 20.67H18.5603C20.1248 20.67 21.0527 20.1158 21.4614 19.421C21.8702 18.7261 21.9043 17.6443 21.1444 16.2737L15.0848 5.36437C14.2684 3.89205 13.3002 3.34253 12.5003 3.34253ZM12.3786 22.16H6.44034C4.54058 22.16 3.0076 21.4748 2.24228 20.1709C1.47739 18.8679 1.62491 17.1947 2.54441 15.5363L8.60443 4.63632C8.60432 4.63652 8.60454 4.63612 8.60443 4.63632C9.56799 2.89899 10.9504 1.84253 12.5003 1.84253C14.0503 1.84253 15.4323 2.89838 16.3959 4.63569L19.3359 9.92569L22.4561 15.546C23.3761 17.2054 23.5205 18.879 22.7543 20.1815C21.988 21.4843 20.4559 22.17 18.5603 22.17H12.5013C12.4595 22.17 12.4185 22.1666 12.3786 22.16Z",
    fill: "#FE0130"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4951 17C11.4951 16.4477 11.9428 16 12.4951 16H12.5041C13.0564 16 13.5041 16.4477 13.5041 17C13.5041 17.5523 13.0564 18 12.5041 18H12.4951C11.9428 18 11.4951 17.5523 11.4951 17Z",
    fill: "#FE0130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalAdvertenciaIcono);
export default __webpack_public_path__ + "static/media/modal-advertencia-icono.1f76896b34b8f3a33613e862de9d4a28.svg";
export { ForwardRef as ReactComponent };